import cs from 'classnames';
import React from 'react';
import { PiMagnifyingGlass, PiQuestion, PiWarningCircle } from 'react-icons/pi';
import { IInputProps } from 'types/components/inputs/input.interface';
import './InputWrapper.scss';
import InputMessage from './message/InputMessage';

interface IInputWrapperProps extends IInputProps {
  render: React.FC<IInputProps>;
}

const InputWrapper = ({
  children,
  error,
  helperText = '',
  isBlocked = false,
  isError,
  label,
  showErrors = true,
  wrapperClassName = '',
  render,
  displayMode,
  disabled,
  isLoading = false,
  borderless = true,
  fullWidth,
  appBackground = false,
  required,
  ...props
}: IInputWrapperProps) => {
  const { className = '', name, style, value, type } = props;

  const showErrorMessage = Boolean(error !== undefined);

  const isMessage = !!error?.length || !!helperText.length;

  const inputContainerClasses = cs('input', {
    'has-value': !!value && value !== -1 && value !== '',
    'has-error': !displayMode && error !== undefined,
    disabled: displayMode ? false : disabled,
    'display-mode': displayMode,
    'is-loading': isLoading,
    borderless,
    fullWidth,
    appBackground,
    [`${type}`]: type,
    [className]: className,
  });

  const inputWrapperClasses = cs(['input-wrapper', wrapperClassName], {
    'is-message': !displayMode && !disabled && isMessage,
  });

  return (
    <div style={{ ...style }} className={inputWrapperClasses}>
      <div className={inputContainerClasses}>
        {isMessage && <InputMessage helperText={helperText} message={error} />}
        {isLoading && <span className="loading-box" />}
        {label && (
          <label htmlFor={name}>
            {label} {required && '*'}
            {!displayMode &&
              isMessage &&
              (showErrorMessage ? (
                <PiWarningCircle className="label-icon warning" />
              ) : (
                <PiQuestion className="label-icon hint" />
              ))}
          </label>
        )}
        {render({ ...props, id: name, disabled: displayMode || disabled })} 
      </div>
    </div>
  );
};

export default InputWrapper;
